import React from 'react';
import PropTypes from 'prop-types';
import {Col, Form} from 'react-bootstrap';
import styled from "styled-components";


export const StyledBlockContent = styled.div`
  border: 1px solid transparent;
  &.fullHeight {
    height: 100%;
  }
  .title {
    // padding-right: calc(1.5em + 0.75rem);
    background-repeat: no-repeat;
    background-position: center right calc(0.375em + 0.1875rem);
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    ${props => !props.hasNavbar && "width: 100%;"}
  };
  .nav {
    display: inline-flex;
    height: 28px;
    float: right;
    .nav-item .nav-link {
      font-size: 14px;
      line-height: 28px;
      text-transform: uppercase;
      padding: 0 7px;
      color: #999999;
      &.active {
        border-bottom: 2px solid #FF513C;
        color: #333333;
      }
    }
  }
  &.is-valid {
    border-color: #28a745;
    .title {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
    }
  };
  &.is-invalid {
    border-color: #dc3545;
    .title {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    }
  };
`;

function Block(props) {
  const { as, lg, md, sm, xl, xs, xxl, fullHeight, ...filteredProps} = props
  const bootstrapProps = { as, lg, md, sm, xl, xs, xxl }
  const style = {whiteSpace: "pre-wrap", ...props.style}

  const className = `${props.className || ''} block ${fullHeight ? 'fullHeight' : ''}`

  if (as) {
    return React.createElement(as, {className, style, ...bootstrapProps}, <BlockContent {...filteredProps} />)
  } else {
    return React.createElement('div', {className, style, ...bootstrapProps}, <BlockContent {...filteredProps} />)
  }
}

function BlockContent(props) {
  const { title, isValid, isInvalid, errors, ...filteredProps} = props

  return (
    <StyledBlockContent
      {...filteredProps}
      className={`block-content ${isValid ? 'is-valid' : ''} ${isInvalid ? 'is-invalid' : ''}`}
      hasNavbar={!!props.navbar}
    >
      {props.title && <div className="title">
        {props.title}
      </div>}
      {props.navbar}
      {props.title && <div className="separator"/>}
      <div className="block-body">
        {props.children}
        {errors && <div style={{marginTop: "10px"}}>
          {errors.map( (error, index) => (
            <Form.Control.Feedback key={index} type="invalid">
              {error}
            </Form.Control.Feedback>))}
        </div>}
      </div>
    </StyledBlockContent>
  )
}

const BlockDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid rgb(200,200,200);
  margin-bottom: 10px;
  margin-top: 10px;
  text-transform: uppercase;
`;

export function Section(props) {
  return <>
  <BlockDivider>{props.title}</BlockDivider>
    <div>{props.children}</div>
  </>
}

Block.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  isValid: PropTypes.bool,
  isInvalid: PropTypes.bool,
  navbar: PropTypes.element,
  as: PropTypes.object
}

export default Block;
